import { render, staticRenderFns } from "./FilterFooter.vue?vue&type=template&id=57f7e4b4&scoped=true"
import script from "./FilterFooter.vue?vue&type=script&lang=ts"
export * from "./FilterFooter.vue?vue&type=script&lang=ts"
import style0 from "./FilterFooter.vue?vue&type=style&index=0&id=57f7e4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7e4b4",
  null
  
)

export default component.exports